export default {
  flood: "Flood Hazard",
  landslide: "Mass Movement Processes",
  urban: "Urban Presence",
  water: "Water Bodies and Rivers",
  expansion: "Urban Expansion Probability",
  risk: "Risk",
  protected: "Protected Areas"
}
